import {
    getMerchantKyc,
  } from "../../services/MerchantKycServices";
  export const MERCHANT_KYC_LIST_INITIATED = "MERCHANT_KYC_LIST_INITIATED";
  export const MERCHANT_KYC_LIST_LOADED = "MERCHANT_KYC_LIST_LOADED";
  export const MERCHANT_KYC_FAILED = "MERCHANT_KYC_FAILED";

  
  export const loadMerchantKyc = (getData) => {
    return (dispatch) => {
      dispatch({ type: MERCHANT_KYC_LIST_INITIATED });
      getMerchantKyc(getData)
        .then((response) => {
          dispatch({ type: MERCHANT_KYC_LIST_LOADED, payload: response.data.data });
        })
        .catch((error) => {
          dispatch({ type: MERCHANT_KYC_FAILED, payload: error.message });
        });
    };
  };